import { render } from "./FormFieldMandatory.vue?vue&type=template&id=3abba946"
import script from "./FormFieldMandatory.vue?vue&type=script&lang=js"
export * from "./FormFieldMandatory.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__